import { Button } from '@chakra-ui/react';
import { FC } from 'react';

export interface ResyncFolderButtonProps {
  onSyncFolder: () => void;
  isSyncing?: boolean;
}

export const ResyncFolderButton: FC<ResyncFolderButtonProps> = ({
  onSyncFolder,
  isSyncing = false,
}) => {
  return (
    <Button
      _active={{ bg: 'blue.700' }}
      _hover={{ bg: 'blue.600' }}
      bg="blue.500"
      color="white"
      isLoading={isSyncing}
      loadingText="Re-syncing..."
      mb={4}
      size="md"
      onClick={onSyncFolder}
    >
      Re-sync folder
    </Button>
  );
};
